import React from 'react';
import { useDispatch } from 'react-redux';

import { Dialog, useMediaQuery } from '@mui/material';
import { closeAllModals } from 'reducers/modalReducer';
import { SMALL_SCREEN_WIDTH } from 'services/constants';

interface ResponsiveDialogProps {
  id: string;
  onClose?: () => any;
  size?: 'sm' | 'md' | 'lg';
}

/**
 * Modal component that has a max width on large screens, but displays full screen on small ones
 */
const ResponsiveDialog = (props: React.PropsWithChildren<ResponsiveDialogProps>) => {
  const dispatch = useDispatch();
  const smallScreen = useMediaQuery(`(max-width:${SMALL_SCREEN_WIDTH})`);
  const { size = 'md' } = props;

  return (
    <Dialog
      id={props.id}
      open={true}
      fullWidth={true}
      aria-labelledby="dialog-title"
      PaperProps={{ square: true }}
      maxWidth={smallScreen ? false : size}
      onClose={props.onClose ? props.onClose() : () => dispatch(closeAllModals())}
    >
      {props.children}
    </Dialog>
  );
};

export default ResponsiveDialog;
